/**
 * React Query hook for fetching community roles
 */

import { useQuery } from "@tanstack/react-query"
import { getCommunityRoles } from "../services/community.service"

export function useCommunityRoles() {
  return useQuery({
    queryKey: ["communityRoles"],
    queryFn: getCommunityRoles,
  })
}
